import api from "./api";
import { User, UserLoginResponse, UserProfileResponse } from "@/types";

// Get current user profile
export const fetchCurrentUser = async (): Promise<User> => {
  return api.get("/user/profile");
};

// Get user by ID
export const fetchUserById = async (userId: string): Promise<User> => {
  return api.get(`/users`, {
    params: {
      id: userId,
    },
  });
};


// Upload user avatar
export const uploadUserAvatar = async (
  file: File
): Promise<{ avatarUrl: string }> => {
  const formData = new FormData();
  formData.append("avatar", file);

  return api.post("/user/avatar", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// Follow/unfollow user
export const toggleUserFollow = async (
  userId: string
): Promise<{ following: boolean }> => {
  return api.post(`/users/${userId}/follow`);
};

// Get user's followers
export const fetchUserFollowers = async (
  userId: string,
  page: number = 1,
  limit: number = 20
): Promise<{
  users: User[];
  hasMore: boolean;
  nextCursor: string | null;
}> => {
  return api.get(`/users/${userId}/followers?page=${page}&limit=${limit}`);
};

// Get user's following
export const fetchUserFollowing = async (
  userId: string,
  page: number = 1,
  limit: number = 20
): Promise<{
  users: User[];
  hasMore: boolean;
  nextCursor: string | null;
}> => {
  return api.get(`/users/${userId}/following?page=${page}&limit=${limit}`);
};

// Get user's posts
export const fetchUserPosts = async (
  userId: string,
  page: number = 1,
  limit: number = 10
): Promise<{
  posts: any[];
  hasMore: boolean;
  nextCursor: string | null;
}> => {
  return api.get(`/users/${userId}/posts?page=${page}&limit=${limit}`);
};

// Search users
export const searchUsers = async (
  query: string,
  page: number = 1,
  limit: number = 20
): Promise<{
  users: User[];
  hasMore: boolean;
  nextCursor: string | null;
}> => {
  return api.get(
    `/users/search?q=${encodeURIComponent(query)}&page=${page}&limit=${limit}`
  );
};

export const LoginByEmail = async (
  e: string,
  p: string
): Promise<
  UserLoginResponse
> => {
  return api.post("/user/email-login", {
    e,
    p,
  });
};
export const verifyEmail = async (
  email: string,
  idToken: string
): Promise<
  UserLoginResponse
> => {
  return api.get("/user/email-reactive", {
    params: {
      email,
      idToken,
    },
  });
};

export const logoutService = async () => {
  return api.post("/user/logout");
};
export const followUserService = async (mediaId: string) => {
  return api.get(`/interact/follow-social-account`, {
    params: {
      mediaId,
    },
  });
};
export const unfollowUserService = async (mediaId: string) => {
  return api.get(`/interact/unfollow-social-account`, {
    params: {
      mediaId,
    },
  });
};

export const getUserInfo = async () => {
  return api.get("/user/info");
};

// Get user profile by ID
export const fetchUserProfile = async (mediaId: string): Promise<UserProfileResponse> => {
  return api.get(`/user/profile`, {
    params: {
      mediaId,
    },
  });
};

export const getUserInfoByUserId = async (userId: string): Promise<UserProfileResponse> => {
  return api.get(`/user/getInfoByUserId`, {
    params: {
      user_id: userId,
    },
  });
};

export const getUserPosts = async (mediaId: string): Promise<any> => {
  const data = await api.get(`/user/profile/posts`, {
    params: {
      mediaId,
    },
  });
  return data;
};
export const getUserPostsByProfileId = async (profile_id: string): Promise<any> => {
  const data = await api.get(`/user/profile/posts`, {
    params: {
      profile_id,
    },
  });
  return data;
};
export const getUserPostsNext = async (mediaId: string, page: number, limit: number): Promise<any> => {
  const data = await api.get(`/user/profile/posts-next`, {
    params: {
      mediaId,
      page,
      limit,
    },
  });
  return data;
}
export const getUserPostsNextByProfileId = async (profile_id: string, page: number, limit: number): Promise<any> => {
  const data = await api.get(`/user/profile/posts-next`, {
    params: {
      profile_id,
      page,
      limit,
    },
  });
  return data;
}

export const getUserReactions = async (mediaId: string): Promise<any> => {
  const data = await api.get<{ result: any }>(`/user/profile/reaction`, {
    params: {
      mediaId,
    },
  });
  // return data.result as unknown as any;
  return data;
}

export const getUserReactionsNext = async (mediaId: string, page: number, limit: number): Promise<any> => {
  const data = await api.get(`/user/profile/reaction`, {
    params: {
      mediaId,
    },
  });
  return data;
}